import { Injectable } from '@angular/core';
import {
  PMSAddressConfig,
  PMS_ADDRESS_CONFIGS,
  AddressFieldConfig,
} from './address-config.interface';
import { PMS } from '../../enums/pms-name.enum';

@Injectable({
  providedIn: 'root',
})
export class AddressConfigService {
  constructor() {}

  getAddressConfig(pmsType: string): PMSAddressConfig {
    return PMS_ADDRESS_CONFIGS[pmsType] || PMS_ADDRESS_CONFIGS['default'];
  }

  getAllConfigs(): { [key: string]: PMSAddressConfig } {
    return PMS_ADDRESS_CONFIGS;
  }

  addCustomConfig(pmsType: string, config: PMSAddressConfig): void {
    PMS_ADDRESS_CONFIGS[pmsType] = config;
  }

  getAvailablePMSTypes(): string[] {
    return Object.keys(PMS_ADDRESS_CONFIGS);
  }

  getFieldsForPMS(pmsType: string): AddressFieldConfig[] {
    const config = this.getAddressConfig(pmsType);
    return config.fields.sort((a, b) => a.order - b.order);
  }

  getValidationMessagesForPMS(pmsType: string): {
    [key: string]: { type: string; message: string }[];
  } {
    const config = this.getAddressConfig(pmsType);
    return config.validationMessages;
  }
}
